export default __webpack_public_path__ + "static/media/Emilio_Ceballos.30cb5bc6.png";